import { FC, HTMLAttributes } from 'react';
import classNames from 'classnames';
import { Hint } from '@redoc/ui-kit';
import st from './HelpHint.module.scss';

interface IHelpHintProps extends HTMLAttributes<HTMLSpanElement> {
	disable?: boolean;
	variant?: 'white' | 'gray';
}

const HelpHint: FC<IHelpHintProps> = ({
	title = '',
	variant = 'gray',
	disable = false,
	className,
	children,
	...otherProps
}) => {
	const classes = classNames(st.hint, st[variant], className, {
		[st.disabled]: disable,
	});

	const content = (
		<span className={classes} tabIndex={-1} {...otherProps}>
			<svg
				width="32"
				height="32"
				viewBox="0 0 32 32"
				fill="inherit"
				xmlns="http://www.w3.org/2000/svg"
				tabIndex={-1}
			>
				<path
					d="M15.1 20.5C15.1 20.9971 15.5029 21.4 16 21.4C16.4971 21.4 16.9 20.9971 16.9 20.5C16.9 20.0029 16.4971 19.6 16 19.6C15.5029 19.6 15.1 20.0029 15.1 20.5ZM16 7C14.8181 7 13.6478 7.23279 12.5558 7.68508C11.4639 8.13738 10.4718 8.80031 9.63604 9.63604C7.94821 11.3239 7 13.6131 7 16C7 18.3869 7.94821 20.6761 9.63604 22.364C10.4718 23.1997 11.4639 23.8626 12.5558 24.3149C13.6478 24.7672 14.8181 25 16 25C18.3869 25 20.6761 24.0518 22.364 22.364C24.0518 20.6761 25 18.3869 25 16C25 14.8181 24.7672 13.6478 24.3149 12.5558C23.8626 11.4639 23.1997 10.4718 22.364 9.63604C21.5282 8.80031 20.5361 8.13738 19.4442 7.68508C18.3522 7.23279 17.1819 7 16 7ZM16 23.2C12.031 23.2 8.8 19.969 8.8 16C8.8 12.031 12.031 8.8 16 8.8C19.969 8.8 23.2 12.031 23.2 16C23.2 19.969 19.969 23.2 16 23.2ZM16 10.6C15.0452 10.6 14.1295 10.9793 13.4544 11.6544C12.9935 12.1153 12.6705 12.6883 12.5119 13.3093C12.3889 13.7909 12.8029 14.2 13.3 14.2C13.7971 14.2 14.1821 13.7732 14.4204 13.337C14.5019 13.1878 14.6048 13.0496 14.7272 12.9272C15.0648 12.5896 15.5226 12.4 16 12.4C16.4774 12.4 16.9352 12.5896 17.2728 12.9272C17.6104 13.2648 17.8 13.7226 17.8 14.2C17.8 15.7925 15.6865 15.8 15.1993 17.8062C15.082 18.2892 15.5029 18.7 16 18.7C16.4971 18.7 16.8791 18.2766 17.0955 17.8291C17.7159 16.546 19.6 16.0795 19.6 14.2C19.6 13.2452 19.2207 12.3295 18.5456 11.6544C17.8705 10.9793 16.9548 10.6 16 10.6Z"
					fill="inherit"
				/>
			</svg>
		</span>
	);

	if (!title) {
		return content;
	}

	return (
		<Hint messageText={title} placement="top" disabled={disable}>
			{content}
		</Hint>
	);
};

export default HelpHint;
